import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EllipsisTooltipComponent } from '@shared/components/general/ellipsis-tooltip/ellipsis-tooltip.component';
import { LoaderComponent } from '@shared/components/general/loader/loader.component';
import { PrimaryContact } from '@shared/interfaces';
import { FieldsetModule } from 'primeng/fieldset';

@Component({
    selector: 'app-order-summary-primary-contact',
    standalone: true,
    imports: [EllipsisTooltipComponent, TranslateModule, FieldsetModule, LoaderComponent],
    templateUrl: './order-summary-primary-contact.component.html',
    styleUrls: ['./order-summary-primary-contact.component.scss'],
})
export class OrderSummaryPrimaryContactComponent {
    @Input({ required: true }) primaryContact: PrimaryContact | null = null;
    @Input() isLoading = false;
}
